import React, { Component } from 'react';
import Collapsible from 'react-collapsible';
import { connect } from 'react-redux';
import _ from 'underscore';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import MANAGED_UX_FORMS_CONTROLLER from '../../controllers/managedUxForms';
import ACCOUNT_SETTINGS_CONTROLLER from '../../controllers/accountSettings';
import { ApplicationMessagesIcons } from '../inAppMessages/ApplicationMessagesIcons';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import Logger, { LOG_LEVELS, ALL_MESSAGES } from '../../utils/logger';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import MappedAccountSettingField from './MappedAccountSettingField';
import AppConfig from '../../utils/appConfig';
import AlertBox from '../modals/AlertBox';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';
import { useReadOnly } from '../../contexts/ReadOnlyContext';

const FORM_NAME = 'ACCOUNT_SETTINGS_FORM';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);

const MAX_FILE_SIZE_IN_MB = AppConfig.UploadConfig.accountSettingsMaxUploadSizeInMB;
const MAX_FILE_SIZE_IN_BYTES = MAX_FILE_SIZE_IN_MB * AppConfig.UploadConfig.bytesPerKB * AppConfig.UploadConfig.bytesPerKB;

class AccountSettingsForm extends Component {

  constructor(props) {
    super(props);    
    this.state = {
      showMaxSizeAlert: false,
      IsFormValid: true,
      errorMessage: ''
    };
    this.setFileInputRef = element => {
      this.fileInput = element;
    };
    this.clearFileInput = () => {
      if (this.fileInput) this.fileInput.value = "";
    };
    this.openMaxFileSizeAlert = this.openMaxFileSizeAlert.bind(this);
    this.closeMaxFileSizeAlert = this.closeMaxFileSizeAlert.bind(this);
  }

  openMaxFileSizeAlert() {
    this.setState({
      showMaxSizeAlert: true
    });
  }

  closeMaxFileSizeAlert() {
    this.setState({
      showMaxSizeAlert: false
    });
    this.clearFileInput();
  }

  render() {
    const {IsFormValid, errorMessage} = this.state;
    log.debug('render(): ', this.props);
    
    return (
      <div data-testid="account-setting-form">
        <ApplicationMessages messageType="applicationError" messageIds={[ALL_MESSAGES.ACCOUNT_SETTINGS_FORM_ERROR]}/>

        { !IsFormValid && <s-alert data-testid="form-error-text" key="account_settings_error" status="error" role="alert" nodismiss={true}>
                            <ApplicationMessagesIcons messageStatus="error" />
                            <LanguageStringResolver string='accountSettingsError'/> 
                            <span>{errorMessage}</span>
                          </s-alert>
        }
        <ReadOnlyWrapper>
          {
            (() => {
              if (!this.props.formData) {
                // waiting for form to initialise
                return (<div></div>)
              }
              return this.props.sortedFieldGroups.map((group, index) => {
                const accountTrigger = <span><s-icon name="chevron-down"></s-icon> {LANGUAGES_CONTROLLER.format(this.props.languages, group.languageString)}</span>;
      
                return (
                  <Collapsible
                    key={index}
                    trigger={accountTrigger}
                    overflowWhenOpen="visible"
                  >
                    <fieldset>
                      {
                        this.props.groupedFieldMappings[group.id].map((mapping, index) => {
                          return (
                            <MappedAccountSettingField
                              key={index}
                              mapping={mapping}
                              onFieldChange={this.onFieldChangeHandlerFactory(mapping.id).bind(this)}
                              value={this.props.formData.fieldValues[mapping.id]}
                            />
                          )
                        })
                      }
                    </fieldset>
                  </Collapsible>
                );
              })
            })()
          }        
          <button className="primary mt15" data-testid="account-submit-button" onClick={this.onSubmitAccountSettings.bind(this)}><LanguageStringResolver string='accountSettings_Submit'/></button>
          <button className="secondary mt15" onClick={this.onResetAccountSettings.bind(this)}><LanguageStringResolver string='accountSettings_Reset'/></button>
          <h2 className="mt20"><LanguageStringResolver string='accountSettings_ImportXMLAccountSettings'/></h2>
          <fieldset>
            <input 
              type="file" 
              ref={this.setFileInputRef}
              onChange={this.onUploadAccountSettings.bind(this)} 
              accept=".xml" />
          </fieldset>
        </ReadOnlyWrapper>
        <AlertBox 
          show={this.state.showMaxSizeAlert} 
          messageKey='accountSettings_fileSizeAlert' 
          onClose={ () => { this.closeMaxFileSizeAlert(); }}
          messageParams={[MAX_FILE_SIZE_IN_MB]}
         />
      </div>
    );
  }
  UNSAFE_componentWillMount() {
    log.debug('componentWillMount(): ', this.props);
    this.props.doInitialiseForm(this.props.settings.reduce((initialFieldValues, setting) => {
      initialFieldValues[setting.name] = setting.value;
      return initialFieldValues;
    }, {}));
  }
  componentWillUnmount() {
    log.debug('componentWillUnmount(): ', this.props);
    this.props.doDestroyForm();
  }
  onFieldChangeHandlerFactory(fieldName) {
    return (evt) => {
      log.clearAllDictionaryErrors();
      this.props.onFieldChange(fieldName, evt.target.value)
    }
  }

  checkFormIsValid(formData) {
    // Checking only for group field name - FileUplodSettings
    const fieldsMapping = this.props.groupedFieldMappings.FileUploadSettings;
    let message = [];
    for (let field in formData) {
      const IsPatternAvailable = fieldsMapping.find((obj) => obj.id === field);
      if (IsPatternAvailable && IsPatternAvailable.pattern != undefined) {
        const fieldValue = formData[field];
        // First check currency pattern values like [USD=0.01|EUR=12]
        const re = new RegExp(IsPatternAvailable.pattern);
        if (fieldValue && !re.test(fieldValue)) {
          message.push(IsPatternAvailable.id);
        }
      }
    }
    return { IsValid: message.length == 0, message: message.join(",") };
  }
  
  onSubmitAccountSettings() {
    log.debug('onSubmitAccountSettings(): ', this.props.formData);
    if (!this.props.formData || typeof this.props.formData.fieldValues !== 'object') {
      return this.props.onSubmit([]); // TODO: Maybe a dialog to confirm blank entry?
    }

    // On new submit,Remove previous error from screen, If there is any
    this.setState({ errorMessage: '' });

    // Check for form validation
    const IsFormValid = this.checkFormIsValid(this.props.formData.fieldValues);
    this.setState({ IsFormValid: IsFormValid.IsValid });
    this.setState({ errorMessage: IsFormValid.message });
    if (!IsFormValid.IsValid) {
      return;
    }

    let changedSettings = [];
    const initialValues = this.props.formData.initialValues || {};
    const fieldValues = this.props.formData.fieldValues || {};

    for (let fieldName in fieldValues) {
      if (initialValues[fieldName] !== fieldValues[fieldName]) {
        changedSettings.push({
          name: fieldName,
          value: fieldValues[fieldName],
        });
      }
    }
    log.debug('onSubmitAccountSettings(): changedSettings: ', changedSettings);
    log.clearAllDictionaryErrors();
    if (changedSettings.length > 0) {
      this.props.onSubmit(changedSettings);
      this.props.doInitialiseForm(fieldValues);
    }
    this.props.doFormSubmitted(FORM_NAME);
  }
  
  onResetAccountSettings() {
    log.clearAllDictionaryErrors();
    log.debug('onResetAccountSettings(): ');
    this.props.doResetForm(FORM_NAME);

  }
  
  onClearAccountSettings() {
    log.debug('onClearAccountSettings(): ');
    this.props.doClearForm(FORM_NAME);

  }

  onUploadAccountSettings(event){    
    if(_.isEmpty(event.target.files)) {
      return;
    }
    let files = event.target.files[0];
    if(!files) {
      return;
    }
    if(files.size <= MAX_FILE_SIZE_IN_BYTES) {
      this.props.importAccountSettings(event.target.files[0], ()=>{
        this.clearFileInput();
      });
    } else {
      this.openMaxFileSizeAlert();
    }
  }

}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): ', state);
  log.debug('mapStateToProps(): props', props);

  const fieldMappings = state.content && state.content.data && state.content.data.accountSettingsFieldMappings;
  const groupedFieldMappings = _.groupBy(fieldMappings, 'groupName');
  const fieldGroups = state.content && state.content.data && state.content.data.accountSettingsGroups;
  const sortedFieldGroups = _.sortBy(fieldGroups, 'displayOrder');

  return {
    fieldMappings,
    fieldMappingsAsArray: Object.values(fieldMappings),
    formData: (state.managedUxForms && state.managedUxForms.forms[FORM_NAME]),
    groupedFieldMappings,
    languages: state.languages,
    sortedFieldGroups
  };
}


function mapDispatchersToProps(dispatch) {
  return {    
    doInitialiseForm: (initialValues) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doInitialiseForm(FORM_NAME, initialValues));
    },
    doResetForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doResetFormFieldsToInitialValues(FORM_NAME));
    },
    doClearForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doClearFormFields(FORM_NAME));
    },
    onFieldChange: (fieldName, value) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormFieldChange(FORM_NAME, fieldName, value));
    },
    doFormSubmitted: (fieldName, value) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormSubmitted(FORM_NAME));
    },
    doDestroyForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doRemoveForm(FORM_NAME));
    },
    importAccountSettings: (accountSettings, callback=()=>{}) => {
      dispatch(ACCOUNT_SETTINGS_CONTROLLER.importAccountSettings(accountSettings, callback));
    }
  }
}

// Wrapper component that uses the ReadOnly context
const AccountSettingsFormWithReadOnly = (props) => {
  const { isReadOnly } = useReadOnly();
  return <AccountSettingsForm {...props} isReadOnly={isReadOnly} />;
};

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(AccountSettingsFormWithReadOnly);
